import React, { useState, FC } from 'react'
import { CreateProps, Edit } from 'react-admin'

import { makeStyles } from '@material-ui/core/styles'

import { CreateToolbar, AsidePreview, CreateForm } from '../containers'

const useStyles = makeStyles({
  container: {
    padding: 8,
  },
  formContainer: {
    backgroundColor: '#F5F5F5',
    padding: 0,
    justifyContent: 'center',
  },
})

export const EditImage: FC<CreateProps> = (props: any) => {
  const {
    showAside = false,
    shouldRedirect = true,
    closeDrawer = false,
    onSubmitSuccess = () => {},
    onSubmitFailure = () => {},
  } = props

  const classes = useStyles()

  const [formData, setFormData] = useState([])

  return (
    <>
      <Edit className={classes.container} {...props}>
        <CreateForm
          {...props}
          title="Editar Imagem"
          setFormData={setFormData}
          toolbar={<CreateToolbar closeDrawer={closeDrawer} />}
          aside={showAside ? <AsidePreview formData={formData} /> : <></>}
          onSubmitSuccess={onSubmitSuccess}
          onSubmitFailure={onSubmitFailure}
          shouldRedirect={shouldRedirect}
          resource="cms/content/images"
        />
      </Edit>
    </>
  )
}
